import SortableTable from './SortableTable';
import SelectableTable from './SelectableTable';

// sortable
[].slice.call(document.querySelectorAll('.table-sortable')).forEach((element: HTMLTableElement) => {
    new SortableTable(element).init();
});
// selectable
[].slice.call(document.querySelectorAll('.table-selectable')).forEach((element: HTMLTableElement) => {
    new SelectableTable(element).init();
});


export default undefined;
